<template>
  <div class="row justify-content-center no-gutters">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
      :background-color="bg_color"
      :color="icon_color"
    ></loading>
    <div class="col col-md-9">
      <div class="row justify-content-center">
<!--        {{ filteredBillings }}-->
      <div v-if="billing_count > 0" v-for="(card, index) in filteredBillings" :key="index" class="mt-2 col-md-10 col-lg-4 col-xl-4 max-xl-670" style="min-width: 380px !important; max-width: 411px !important;">
        <div class="stripe-warning" hidden>To avoid interuptions to your subscriptions and purchases, verify your payment information.</div>
        <div v-if="card.primary === true" :class="card.gateway == 'stripe' ? 'card card-bill-primary card-bill' : 'card card-bill-primary card-bill' " @click="card.gateway == 'stripe' ? handleCardForm(card, 0) : handleCardForm(card, 0)">
          <div class="card-body">
            <div class="text-left" style="padding: 20px 20px 3px 20px;">
                <span data-current-language="tr_TR" style="display: block">
                  <div>
                    <span class="card-label">Card Number:</span>
                    <p style="display: inline-block; width: 100%" class="card-number">**** **** **** {{ card.card.last4 }}</p>
                  </div>
                  <div>
                    <span class="card-label">Expiration Date:</span>
                    <p style="display: inline-block; width: 100%">{{ card.card.expiry_month }} / {{ card.card.expiry_year }}</p>
                  </div>

                  <div v-if="card.card.brand === 'visa'" class="card-icon">
                    <img :src="base_url + '/img/visa.jpg'"/>
                  </div>
                  <div v-else-if="card.card.brand === 'mastercard'" class="card-icon">
                    <img :src="base_url + '/img/mastercard.jpg'"/>
                  </div>
                  <div v-else class="card-icon">
                    <img :src="base_url + '/img/amex.jpg'"/>
                  </div>
                </span>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-8">
                  <span role="alert" class="alert alert-" style="display: none;">
                    <div class="row">
                      <div class="col-1">
                        <span class="flash-icon"><!----></span>
                      </div>
                      <div class="col"><span></span>
                      </div>
                    </div>
                  </span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="card card-bill" @click="handleCardForm(card,0)">
          <div class="card-body">
            <div class="text-left" style="padding: 20px 20px 3px 20px;">
                <span data-current-language="tr_TR" style="display: block">
                  <div>
                    <span class="card-label">Card Number:</span>
                    <p style="display: inline-block; width: 100%" class="card-number">**** **** **** {{ card.card.last4 }}</p>
                  </div>
                  <div>
                    <span class="card-label">Expiration Date:</span>
                    <p style="display: inline-block; width: 100%">{{ card.card.expiry_month }} / {{ card.card.expiry_year }}</p>
                  </div>
                  <div v-if="card.card.brand === 'visa'" class="card-icon">
                    <img :src="base_url + '/img/visa.jpg'"/>
                  </div>
                  <div v-else-if="card.card.brand === 'mastercard'" class="card-icon">
                    <img :src="base_url + '/img/mastercard.jpg'"/>
                  </div>
                  <div v-else class="card-icon">
                    <img :src="base_url + '/img/amex.jpg'"/>
                  </div>
                </span>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-8">
                  <span role="alert" class="alert alert-" style="display: none;">
                    <div class="row">
                      <div class="col-1">
                        <span class="flash-icon"><!----></span>
                      </div>
                      <div class="col"><span></span>
                      </div>
                    </div>
                  </span>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="card card-bill add-card-bill" @click="handleCardForm('mode', 1)">
          <div class="card-body">
            <div class="text-left" style="padding: 20px;">
                <span data-current-language="tr_TR" style="display: block">
                  <div class="text-center">
                   <svg width="1em" style="font-size: 70px;" height="1em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                  </svg>
                  </div>
                  <div class="text-center">
                    <p>Add New Card</p>
                  </div>
                </span>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-8">
                  <span role="alert" class="alert alert-" style="display: none;">
                    <div class="row">
                      <div class="col-1">
                        <span class="flash-icon"><!----></span>
                      </div>
                      <div class="col"><span></span>
                      </div>
                    </div>
                  </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    form modal-->
    <modal
      name="card-modal"
      width="100%"
      height="auto">
      <div style="display: block !important; width: 100% !important;">
        <div class="row no-gutters">
          <div class="col col-12">
            <div class="text-center">
              <p class="h5">{{ title }}</p>
            </div>
            <div class="card" style="border: none !important; background-image: none !important; background-color: transparent !important; box-shadow: none !important;">
              <div class="card-body card-container" style="overflow-y: auto !important; background-image: none !important; max-height: 600px !important;">
                <div v-if="formMode === 0">
                  <form
                    ref="form"
                    :model="customer_data"
                    method="POST">
                    <div class="form-group justify-content-start align-items-center row mb-1">
                      <label class="col-4 mx-250"><span>Card Number</span></label>
                      <div class="col-12 col-sm-8 col-md-8 mx-400">
                        <input
                          :id="card_number"
                          class="form-control pristine touched"
                          name="card_number"
                          type="text"
                          :disabled="true"
                          required
                          v-model="card_number"
                        >
                      </div>
                    </div>
                    <div class="form-group justify-content-start align-items-center row mb-1">
                      <label class="col-4 mx-250"><span>Expiration Date</span></label>

                      <div class="col-4 col-sm-3 col-md-3 mx-400">
                        <span style="display: block">
                          <span style="display: inline-block; float: left; padding: 10px; color: rgba(255, 255, 255, .55);">MM</span>
                        <input
                          :id="customer_data.expiry_month"
                          :disabled="true"
                          class="form-control pristine touched"
                          name="expiry_month"
                          type="text"
                          required
                          v-model="customer_data.expiry_month"
                          style="display: inline-block !important;width: 60% !important;"
                        >
                          </span>
                      </div>
                      /
                      <div class="col-4 col-sm-3 col-md-3 mx-400">
                        <span style="display: block">
                          <span style="display: inline-block; float: left; padding: 10px; color: rgba(255, 255, 255, .55);">YY</span>
                        <input
                          :id="customer_data.expiry_year"
                          :disabled="true"
                          class="form-control pristine touched"
                          name="expiry_year"
                          type="text"
                          required
                          v-model="customer_data.expiry_year"
                          style="display: inline-block !important;width: 70% !important;"
                        >
                          </span>
                      </div>
                    </div>
                    <div class="form-group justify-content-start align-items-center row mb-1">
                      <label class="col-4 mx-250"><span v-translate>Card Brand</span></label>
                      <div class="col-12 col-sm-8 col-md-8 mx-400">
                        <div v-if="brand === 'visa'">
                          <img :src="base_url + '/img/visa.jpg'"/>
                        </div>
                        <div v-else-if="brand === 'mastercard'">
                          <img :src="base_url + '/img/mastercard.jpg'"/>
                        </div>
                        <div v-else>
                          <img :src="base_url + '/img/amex.jpg'"/>
                        </div>
                      </div>
                    </div>
                    <div class="form-group justify-content-start align-items-center row mb-1">
                      <label class="col-4 mx-250"><span v-translate>FIRST NAME</span></label>
                      <div class="col-12 col-sm-8 col-md-8 mx-400">
                        <input
                          :id="customer_data.first_name"
                          :disabled="disabled ? true : false"
                          class="form-control pristine touched"
                          name="firstname"
                          type="text"
                          required
                          v-model="customer_data.first_name"
                        >
                      </div>
                    </div>
                    <div class="form-group justify-content-start align-items-center row mb-1">
                      <label class="col-4 mx-250"><span v-translate>LAST NAME</span></label>
                      <div class="col-12 col-sm-8 col-md-8 mx-400">
                        <input
                          :id="customer_data.last_name"
                          :disabled="disabled ? true : false"
                          class="form-control"
                          name="lastname"
                          type="text"
                          required
                          v-model="customer_data.last_name"
                        >
                      </div>
                    </div>
                    <div class="form-group justify-content-start align-items-center row mb-1">
                      <label class="col-4 mx-250"><span v-translate>BILLING ADDRESS 1</span></label>
                      <div class="col-12 col-sm-8 col-md-8 mx-400">
                        <input
                          :id="customer_data.billing_addr1"
                          :disabled="disabled ? true : false"
                          class="form-control pristine touched"
                          name="billingadd1"
                          type="text"
                          required
                          v-model="customer_data.billing_addr1"
                        >
                      </div>
                    </div>
                    <div class="form-group justify-content-start align-items-center row mb-1">
                      <label class="col-4 mx-250"><span v-translate>BILLING ADDRESS 2</span></label>
                      <div class="col-12 col-sm-8 col-md-8 mx-400">
                        <input
                          :id="customer_data.billing_addr2"
                          :disabled="disabled ? true : false"
                          class="form-control pristine touched"
                          name="billingadd2"
                          type="text"
                          required
                          v-model="customer_data.billing_addr2"
                        >
                      </div>
                    </div>
                    <div class="form-group justify-content-start align-items-center row mb-1">
                      <label class="col-4 mx-250"><span v-translate>BILLING CITY</span></label>
                      <div class="col-12 col-sm-8 col-md-8 mx-400">
                        <input
                          :id="customer_data.billing_city"
                          :disabled="disabled ? true : false"
                          class="form-control pristine touched"
                          name="billingcity"
                          type="text"
                          required
                          v-model="customer_data.billing_city"
                        >
                      </div>
                    </div>
                    <div class="form-group justify-content-start align-items-center row mb-1">
                      <label class="col-4 mx-250"><span v-translate>BILLING STATE</span></label>
                      <div class="col-12 col-sm-8 col-md-8 mx-400">
                        <input
                          :id="customer_data.billing_state"
                          :disabled="disabled ? true : false"
                          class="form-control pristine touched"
                          name="billingstate"
                          type="text"
                          required
                          v-model="customer_data.billing_state"
                        >
                      </div>
                    </div>
                    <div class="form-group justify-content-start align-items-center row mb-1">
                      <label class="col-4 mx-250"><span v-translate>BILLING COUNTRY</span></label>
                      <div class="col-12 col-sm-8 col-md-8 mx-400">
                        <input
                          :id="customer_data.billing_country"
                          :disabled="disabled ? true : false"
                          class="form-control pristine touched"
                          name="billingcountry"
                          type="text"
                          required
                          v-model="customer_data.billing_country"
                        >
                      </div>
                    </div>
                    <div class="form-group justify-content-start align-items-center row mb-1">
                      <label class="col-4 mx-250"><span v-translate>BILLING ZIP</span></label>
                      <div class="col-12 col-sm-8 col-md-8 mx-400">
                        <input
                          :id="customer_data.billing_zip"
                          :disabled="disabled ? true : false"
                          class="form-control pristine touched"
                          name="billingzip"
                          type="text"
                          required
                          v-model="customer_data.billing_zip"
                        >
                      </div>
                    </div>
                  </form>
                </div>
                <div v-else class="card-content">
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label class="cb-input-card-label">First Name *:</label>
                        <input type="text" v-model="cardForm.first_name" :data-error="(cardErrors.firstName)?true:false" class="form-control pristine touched" placeholder="First Name">
                        <span v-if="cardErrors.firstName" class="error-inline ">{{cardErrors.firstName}}</span>
                      </div>
                      <div class="form-group col-md-6">
                        <label class="cb-input-card-label">Last Name *:</label>
                        <input type="text" v-model="cardForm.last_name" :data-error="(cardErrors.lastName)?true:false" class="form-control pristine touched" placeholder="Last Name">
                        <span v-if="cardErrors.lastName" class="error-inline ">{{cardErrors.lastName}}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="cb-input-card-label">Credit Card Number *:</label>
                      <input type="text" v-model="cardForm.number" :data-error="(cardErrors.cardNumber)?true:false"  class="form-control pristine touched" v-cardformat:formatCardNumber placeholder="Card Number">
                      <span v-if="cardErrors.cardNumber" class="error-inline ">{{cardErrors.cardNumber}}</span>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label class="cb-input-card-label">Expiry *:</label>
                        <input type="text" v-model="cardForm.expiry" :data-error="(cardErrors.cardExpiry)?true:false" class="form-control pristine touched" v-cardformat:formatCardExpiry placeholder="MM/YYYY" :maxlength="5">
                        <span v-if="cardErrors.cardExpiry" class="error-inline ">{{cardErrors.cardExpiry}}</span>
                      </div>
                      <div class="form-group col-md-6">
                        <label class="cb-input-card-label">CVC *:</label>
                        <input type="text" v-model="cardForm.cvv" :data-error="(cardErrors.cardCVV)?true:false" class="form-control pristine touched" v-cardformat:formatCardCVC placeholder="CVV">
                        <span v-if="cardErrors.cardCVV" class="error-inline ">{{cardErrors.cardCVV}}</span>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col col-12 text-right">
            <span v-if="formMode !== 1" style="display: inline-block">
              <a v-if="is_primary === false" href="#" class="btn btn-warning" @click="handleSetPrimary()" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Set as Primary Card</span>
              </a>
              <a v-else href="#" class="btn btn-done btn-primary-card" style="margin-right: 20px;">
                <span data-current-language="tr_TR" style="color: #ffffff !important;">Primary Card</span>
              </a>
              <a href="#" class="btn btn-success" @click="handleEdit(customer_data)" style="margin-right: 20px;">
                <span data-current-language="tr_TR">{{ edit_caption }}</span>
              </a>
              <a href="#" class="btn btn-danger" @click="handleCardDeleteConfirmation" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Delete</span>
              </a>
              <a href="#" class="btn btn-outline-primary btn-outline-subscribed" @click="hideModal()" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Close</span>
              </a>
            </span>
            <span v-else style="display: inline-block">
              <a href="#" class="btn btn-success" @click="validateCard" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Save</span>
              </a>
              <a href="#" class="btn btn-outline-primary btn-outline-subscribed" @click="hideModal()" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Close</span>
              </a>
            </span>
          </div>
        </div>
      </div>

      <span
        class="modal-close"
        @click="hideModal">
          <svg-rndr svg="close.svg" />
      </span>

    </modal>

    <modal
      name="confirmation-modal"
      width="100%"
      height="auto">
      <div style="display: block !important; width: 100% !important;">
        <div class="row no-gutters">
          <div class="col col-12">
            <div class="text-center">
              <p class="h5">Delete Card</p>
            </div>
            <div class="card" style="border: none !important; background-image: none !important; background-color: transparent !important; box-shadow: none !important;">
              <div class="card-body" style="background-image: none !important;">
                <div class="text-center">
                  <p data-current-language="tr_TR" class="h5 subs-card-content-title">Are You sure you want to delete this card {{ card_number }}?</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col col-12 text-right">
            <span style="display: inline-block">
              <a href="#" class="btn btn-success" @click="handleDeleteCard" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Yes</span>
              </a>
              <a href="#" class="btn btn-outline-primary btn-outline-subscribed" @click="hideConfirmationModal()" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Cancel</span>
              </a>
            </span>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Input from '@C/Forms/Input';
import Checkbox from '@C/Checkbox';
import {CardComponent, CardNumber, CardExpiry, CardCvv} from '@chargebee/chargebee-js-vue-wrapper';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "BillingTab",
  components: {
    Input,
    Checkbox,
    CardComponent,
    CardNumber,
    CardExpiry,
    CardCvv,
    Loading
  },
  props: {
    subscriptions_data: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      isLoading: false,
      bg_color: '#000',
      icon_color: '#fff',
      fullPage: true,
      dialogOptions: false,
      dialogTitle: '',
      selectedOptions: [],
      subscriptionData: [],
      billings: [],
      disabled: true,
      all_products: [],
      base_url: window.ENV.BASE_URL,
      result: [],
      combi_result: [],
      customer_group: '',
      chargebee_subscription_id: '',
      subscriptionStatus: '',
      price: '',
      title: '',
      data_ser: {},
      formMode: 0,
      card_data: {},
      is_primary: false,
      card_number: '',
      expiry_year: '',
      expiry_month: '',
      status: '',
      cvv: '',
      brand: '',
      customer_id: '',
      card_id: '',
      edit_caption: 'EDIT',
      //Chargebee
      token: "",
      errMsgToken: "",
      loading: false,
      firstName: "",
      // data_set: {},
      billing_count: 0,
      next_due_date: 'YYYY-MM-DD',
      tocancelData: '',
      term: '',
      access_to_subscription: '',
      to_take: '',
      show_card_form: false,
      nextdue_is_morethan: false,
      cancel_step: 1,
      options: [{
        value: 'Manage Subscription',
        label: 'Manage Subscription'
      }],
      // Options for card-component
      // custom classes
      classes: {
        focus: "focus",
        invalid: "invalid",
        empty: "empty",
        complete: "complete",
      },
      // Custom fonts
      fonts: ["https://fonts.googleapis.com/css?family=Lato:400,700"],
      // Placeholders
      placeholder: {
        number: "Card Number",
        cvv: "CVV",
        expiry: "MM / YY",
      },
      // Locale
      locale: "en",
      // Custom styles
      styles: {
        base: {
          color: '#dfe2ec',
          fontWeight: 600,
          fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',
          fontSize: '16px',
          fontSmoothing: 'antialiased',
          ':focus': {
            color: '#dfe2ec'
          },

          '::placeholder': {
            color: '#9BACC8'
          },

          ':focus::placeholder': {
            color: '#CFD7DF'
          }
        },
        invalid: {
          color: '#39467b',
          ':focus': {
            color: '#FA755A'
          },
          '::placeholder': {
            color: '#FFCCA5'
          }
        }
      },
      data_set: {},
      customer_data: {},
      cardForm:{},
      cardErrors: {},
      jwtToken: '',
      isStripe: false,
      stripePaymentSource: {},
    }
  },
  computed: {
    filteredBillings() {
      return this.billings.sort(function(a,b){return b.primary - a.primary});
    },
  },
  created() {
    this.getBilling()
  },
  methods: {
    getToken (e) {
      e.preventDefault()
      console.log(e)
      this.isLoading = true
        this.$refs.card
          .tokenize({})
          .then((data) => {
            this.cb_token_id = data.token;
            // this.handleSubscribe()
            this.handleAddCard()
            // this.$refs.cardComponent.tokenize().then(data => {
          }).catch(error => {
          console.log(error)
          this.$toasted.show('Invalid Card Details!', {
            type : 'error',
            // icon : 'error_outline',
            position: 'top-center',
            duration: 3000,
          })
          this.isLoading = false
        })
    },
    validateCard(e){
      // init
        e.preventDefault()
        this.isLoading = true
        this.cardErrors = {};
        let isValidCard = true;

        // validate first name
        if (this.cardForm.first_name == '') {
            this.cardErrors.firstName = "Invalid First Name.";
            isValidCard = false;
            this.isLoading = false;
        }

        // validate first name
        if (this.cardForm.last_name == '') {
            this.cardErrors.lastName = "Invalid First Name.";
            isValidCard = false;
            this.isLoading = false;
        }

        // validate card number
        if(!this.$cardFormat.validateCardNumber(this.cardForm.number)){
            this.cardErrors.cardNumber = "Invalid Credit Card Number.";
            isValidCard = false;
            this.isLoading = false;
            console.log('---Invalid Card Number---');
        };

        // validate card expiry
        if (!this.$cardFormat.validateCardExpiry(this.cardForm.expiry)) {
            this.cardErrors.cardExpiry = "Invalid Expiration Date.";
            isValidCard = false;
            this.isLoading = false;
            console.log('---Invalid Card Expiry---');
        };

        // validate card CVC
        if (!this.$cardFormat.validateCardCVC(this.cardForm.cvv)) {
            this.cardErrors.cardCVV = "Invalid CVV.";
            isValidCard = false;
            this.isLoading = false;
            console.log('---Invalid Card CVV---');
        };

        if (this.isStripe) {
            let digitsWithoutSpaces = this.cardForm.number.replace(/\s/g, ''); // Remove spaces
            let lastFourDigits = digitsWithoutSpaces.substr(-4); // Get the last 4 digits
            if (lastFourDigits != this.stripePaymentSource.card.last4 ) {
                this.cardErrors.cardNumber = "Please use the same card details.";
                isValidCard = false;
                this.isLoading = false;
            }
        }

        if(isValidCard) {
            console.log('---JWT tokenize---');
            this.jwtTokenize();
        }

    },
    jwtTokenize() {
        const secret = process.env.MIX_JWT_SECRET_KEY;
        let date = this.cardForm.expiry.split('/');
        let month = date[0].replace(/\s+/g, ' ').trim();
        let year = date[1].replace(/\s+/g, ' ').trim();
        const payload = {
            customer_id: this.$attrs.user.chargebee_id,
            expiry_month: month,
            expiry_year: year,
            cvv: this.cardForm.cvv,
            number: this.cardForm.number,
            first_name: this.cardForm.first_name,
            last_name: this.cardForm.last_name
        };

        const token = window.jwt.sign(payload, secret, {
            algorithm: process.env.MIX_JWT_ENCRYPTION_TYPE,
            expiresIn: process.env.MIX_JWT_EXPIRATION, // if ommited, the token will not expire
        })

        if(token) {
            this.jwtToken = token;
            this.handleAddCardV2();
        } else {
            this.isLoading = false
            this.$toasted.show('There is a problem while tokenizing your card! Please try again.', {
                type : 'error',
                // icon : 'error_outline',
                position: 'top-center',
                duration: 3000,
            })
        }
    },
    handleAddCardV2() {
        const action = 'add'; //this.isStripe ? 'migrate' : 'add';
        const url = '/apis/v1/payment-source/' + action;
        const config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + process.env.MIX_PORTAL_BEARER_TOKEN,
            },
        }

        axios.post(url, {
            provider: 'chargebee',
            requestOptions: {
            params: {
                card_details: this.jwtToken,
                region: this.$attrs.user.region,
                customer_type: this.$attrs.user.customer_type,
                salesforce_token: this.$attrs.user.salesforce_token,
                stripe_payment_source_id: this.stripePaymentSource.id,
                user_id: this.$attrs.user.id
            }
            },
        }, config)
        .then(response => {
            if(response.data.meta.total_records == 1) {
            this.isLoading = false
            this.billings = []
            this.$emit('changedbilling')
            this.hideModal()
            this.$toasted.show('Card Successfully Added!', {
                type : 'success',
                // icon : 'error_outline',
                position: 'top-center',
                duration: 3000,
            })
            } else {
            this.isLoading = false
            this.hideModal()
            this.$toasted.show(response.data.errors[0].detail, {
                    type : 'error',
                    position: 'top-center',
                    duration: 3000,
                })
            }
            this.cardForm = {}
            this.cardErrors = {}
        })
        .catch(error => {
            this.$toasted.show(error, {
                type : 'error',
                position: 'top-center',
                duration: 3000,
            })
            this.isLoading = false
        })
    },
    handleAddCard() {
      this.isLoading = true
      let url = "/widget/card/add"
      axios.post(url,
        {
          cb_token: this.cb_token_id
        })
        .then(response => {
          if(response.data.status === 'success') {
            this.isLoading = false
            this.billings = []
            this.$emit('changedbilling')
            this.hideModal()
            this.$toasted.show('Card Successfully Added!', {
              type : 'success',
              // icon : 'error_outline',
              position: 'top-center',
              duration: 3000,
            })
          } else {
            this.isLoading = false
            this.hideModal()
            this.$toasted.show(response.data.display_message, {
              type : 'error',
              position: 'top-center',
              duration: 3000,
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.isLoading = false
        })
    },
    handleCardDeleteConfirmation() {
      this.$modal.show('confirmation-modal');
    },
    handleDeleteCard(e) {
      this.isLoading = true
      let card_id = this.card_id;
      let url = "/widget/card/delete";
      axios.post(url,
        {
          id: card_id
        })
        .then(response => {
          if(response.data.status === 'success') {
            this.isLoading = false
            this.billings = []
            this.$emit('changedbilling')
            this.hideConfirmationModal()
            this.hideModal()
            this.$toasted.show('Card successfully Deleted!', {
              type : 'success',
              // icon : 'error_outline',
              position: 'top-center',
              duration: 3000,
            })
          } else {
            this.isLoading = false
            this.hideConfirmationModal()
            this.hideModal()
            this.$toasted.show(response.data.display_message, {
              type : 'error',
              // icon : 'error_outline',
              position: 'top-center',
              duration: 3000,
            })
            // this.isLoading = false
          }
        })
        .catch(error => {
          console.log(error)
          this.isLoading = false
        })
    },
    handleSetPrimary() {
      this.isLoading = true
      let card_id = this.card_id;
      let url = "/widget/card/set-primary";
      axios.post(url,
        {
          id: card_id
        })
        .then(response => {
          if(response.data.status === 'success') {
            this.isLoading = false
            this.billings = []
            this.$emit('changedbilling')
            this.disabled = true
            this.hideModal()
            this.$toasted.show('Card successfully Set as Primary!', {
              type : 'success',
              // icon : 'error_outline',
              position: 'top-center',
              duration: 3000,
            })
          } else {
            this.isLoading = false
            this.disabled = true
            this.edit_caption = 'EDIT'
            this.hideModal()
            this.$toasted.show(response.data.display_message, {
              type : 'error',
              // icon : 'error_outline',
              position: 'top-center',
              duration: 3000,
            })
            // this.isLoading = false
          }
        })
        .catch(error => {
          console.log(error)
          this.isLoading = false
        })

    },
    handleEdit() {
      if(this.edit_caption === 'EDIT') {
        this.edit_caption = 'SAVE'
        this.disabled = false
      } else {
        this.isLoading = true
        console.log(this.customer_data,'cusdata')
        this.handleEditCard()
        this.disabled = true
        this.edit_caption = 'EDIT'
      }
    },
    handleEditCard() {
      let card_id = this.card_id;
      // console.log
      let card = this.customer_data;

      let firstName = ''
      let lastName = ''
      let billing_addr1 = ''
      let billing_addr2 = ''
      let billing_city = ''
      let billing_state = ''
      let billing_country = ''
      let billing_zip = ''
      if(this.customer_data.first_name) {
        firstName = this.customer_data.first_name
      }
      if(this.customer_data.first_name) {
        lastName = this.customer_data.last_name
      }
      if(this.customer_data.billing_addr1) {
        billing_addr1 = this.customer_data.billing_addr1
      }
      if(this.customer_data.billing_addr2) {
        billing_addr2 = this.customer_data.billing_addr2
      }
      if(this.customer_data.billing_city) {
        billing_city = this.customer_data.billing_city
      }
      if(this.customer_data.billing_state) {
        billing_state = this.customer_data.billing_state
      }
      if(this.customer_data.billing_country) {
        billing_country = this.customer_data.billing_country
      }
      if(this.customer_data.billing_zip) {
        billing_zip = this.customer_data.billing_zip
      }
      let url = "/widget/card/update";
      this.isLoading = true
      axios.post(url,
        {
          id: card_id,
          card: {
            firstName: firstName,
            lastName: lastName,
            billingAddr1: billing_addr1,
            billingAddr2: billing_addr2,
            billingCity: billing_city,
            billingState: billing_state,
            billingCountry: billing_country,
            billingZip: billing_zip
          }
        })
        .then(response => {
          if(response.data.status === 'success') {
            this.isLoading = false
            this.billings = []
            this.$emit('changedbilling')
            this.disabled = true
            this.edit_caption = 'EDIT'
            this.hideModal()
            this.$toasted.show('Card successfully Updated!', {
              type : 'success',
              // icon : 'error_outline',
              position: 'top-center',
              duration: 3000,
            })
          } else {
            this.isLoading = false
            this.disabled = true
            this.edit_caption = 'EDIT'
            this.hideModal()
          }
        })
        .catch(error => {
          console.log(error)
          this.isLoading = false
        })
    },
    hideModal() {
      this.$modal.hide('card-modal');
      this.$modal.hide('confirmation-modal');
      this.edit_caption = 'EDIT'
      this.disabled = true
    },
    hideConfirmationModal() {
      this.$modal.hide('confirmation-modal');
      this.disabled = true
    },
    handleCardForm(value, mode) {
      this.isLoading = true
      this.formMode = mode
      if(mode === 1) {
        this.title = 'Add New Card'
        this.isLoading = false
        this.isStripe = false

        if (value.gateway == 'stripe') {
            this.isStripe = true
            this.stripePaymentSource = value
            this.cardForm.expiry = value.card.expiry_month + '/' + value.card.expiry_year
        }
      } else {
        this.card_data = value
        if(value.primary === true) {
          this.is_primary = true
        } else {
          this.is_primary = false
        }

        this.card_number = value.card.masked_number
        this.card_id = value.id
        this.expiry_month = value.card.expiry_month.toString()
        this.expiry_year= value.card.expiry_year.toString()
        this.status = value.status
        this.brand = value.card.brand
        this.title = 'Edit Card Details'

        let url = "/widget/card/get";

        axios.post(url,
          {
            id: this.card_id
          })
          .then(response => {
            if(response.data.status === 'success') {
              this.customer_data = response.data.card.card
              console.log(this.customer_data,'data')
              this.isLoading = false
            } else {
              this.$toasted.show(response.data.display_message, {
                type : 'error',
                // icon : 'error_outline',
                position: 'top-center',
                duration: 3000,
              })
              this.isLoading = false
            }
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
          })
      }

      this.$modal.show('card-modal');
    },
    getBilling(value) {
      if(value) {
        this.data_set = value.billing
      } else {
        this.data_set = this.subscriptions_data.billing
      }
      this.billing_count = this.data_set.length
      this.billings = this.data_set

    },
    reloadData(data) {
      this.getBilling(data)
    },
    filterDuplicatePaymentSource(paymentSources) { // This remove the stripe gateway payment source that is already updated to paypal gateway
      if (paymentSources.length <= 1) {
          return paymentSources;
      }

      const hasDuplicates = paymentSources.some((source, index, self) => {
          return (
              source.gateway === "stripe" &&
              self.some(
                  (otherSource) =>
                      otherSource.gateway === "paypal_pro" &&
                      otherSource.card.last4 === source.card.last4 &&
                      otherSource.card.expiry_month === source.card.expiry_month &&
                      otherSource.card.expiry_year === source.card.expiry_year
              )
          );
      });

      if (!hasDuplicates) {
          return paymentSources;
      }

      const filteredPaymentSources = paymentSources.filter((source, index, self) => {
          if (
              source.gateway === "stripe" &&
              self.some(
                  (otherSource) =>
                      otherSource.gateway === "paypal_pro" &&
                      otherSource.card.last4 === source.card.last4 &&
                      otherSource.card.expiry_month === source.card.expiry_month &&
                      otherSource.card.expiry_year === source.card.expiry_year
              )
          ) {
              return false;
          }
          return true;
      });

      return filteredPaymentSources;
    }
  }
}
</script>

<style scoped>
.card.card-bill > .card-body {
  background-color: #057FB2 !important;
  background-image: none !important;
  border-radius: 12px !important;
}

.card.card-bill {
  background-color: #057FB2 !important;
  border: 2px solid rgba(0, 0, 0, 0.125);
  border-radius: 12px !important;
  cursor: pointer !important;
  transition: 0.3s !important;
}

.card.card-bill:hover {
  background-color: #fff !important;
  border: 2px solid rgba(0, 0, 0, 0.125) !important;
  border-radius: 12px !important;
  cursor: pointer !important;
}
.card.card-bill-primary {
  background-color: #057FB2 !important;
  border: 2px solid rgba(0, 0, 0, 0.125);
  border-radius: 12px !important;
}
.card.card-bill-primary > .card-body {
  background-color: #057FB2 !important;
  background-image: none !important;
  border-radius: 12px !important;
}
p.card-number {
  font-size: 25px !important;
  font-family: monospace;
  font-weight: 300 !important;
}

span.card-label {
  color: rgba(255, 255, 255, .4) !important;

}

.card.card-bill-primary.card-bill::after {
  content: 'primary' !important;
  position: absolute !important;
  bottom: 0 !important;
  background-color: #ff9a03 !important;
  width: 80px !important;
  padding: 2px !important;
  text-align: center !important;
  border-bottom-left-radius: 11px !important;
}

.card-icon {
  float: right;
  margin-top: -40px;
}

.card-icon > img {
  width: 60px !important;
}

.card.card-bill.add-card-bill {
  border: 2px dashed rgba(255, 255, 255, 0.2) !important;
  border-radius: 9px !important;
  color: #a2b0d5 !important;
  background-color: transparent !important;
  /* margin-top: 9px !important; */
  cursor: pointer !important;
  /* opacity: 0 !important; */
  -webkit-transition: 0.3s !important;
  transition: 0.3s !important;
  width: 364px !important;
  margin: 9px 10px 0 8px !important;
  max-height: 204px !important;

}
.card.card-bill.add-card-bill:hover {
  background-color: rgba(255, 255, 255, .09) !important;
  /*opacity: 1 !important;*/
}
.card.card-bill.add-card-bill > .card-body {
  background-color: transparent !important;
  padding: 1rem 1rem 0 1rem !important;
}
.mt-2, .my-2 {
  margin-bottom: 0.5rem !important;
  padding: 0 8px !important;
}

.btn {
  background-image: none !important;
}
a.btn-outline-subscribed {
  border: 1px solid rgba(255, 255, 255, .25) !important;
  color: #fff !important;
}

input[type=checkbox]:after {
  font-size: 20px !important;
  color: white !important;
}
.btn-primary-card {
  position: absolute;
  background-color: orange;
  border-radius: 0px;
  left: -20px;

}
.form-control {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: rgba(255, 255, 255, 0.85) !important;
  border: 1px solid rgba(226, 246, 255, 0.3) !important;
}

form .form-control:disabled, .form .form-control:disabled {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: rgba(255, 255, 255, 0.55) !important;
}
.CardForm input {
  color: rgba(255, 255, 255, .73) !important;
}
.card-container {
  overflow-y: auto !important;
}

.highlight-stripe {
    border: 2px solid #ef4444 !important;
}

.stripe-warning {
    border: 1px dashed #ef4444;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    color: #ef4444;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/Tabs/Billing.vue